import styles from './vehicle_logo.module.scss';
import {classNames} from '../../support/classnames.ts';

export enum VehicleLogoSize {
    Large,
    Medium,
    Small,
}

interface OwnProps {
    alt: string;
    size?: VehicleLogoSize;
    src?: string;
}
export function VehicleLogo({alt, size, src}: OwnProps) {
    return (
        <div
            className={classNames(styles.vehicle_logo, {
                [styles.large]: size === VehicleLogoSize.Large,
                [styles.medium]: size === VehicleLogoSize.Medium,
                [styles.small]: size === VehicleLogoSize.Small,
            })}
        >
            <div className={styles.vehicle_logo__image}>
                {src && <img src={src} alt={alt} onError={(e) => (e.currentTarget.style.display = 'none')} />}
            </div>
        </div>
    );
}
